module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/207/assets/images/f4e7bd300d174843b362a10db2961ae6.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/ico_edit.svg
// module id = fPvb
// module chunks = 1